import { NAV_LINKS, scrollToId } from "@/lib/site";
import { WordmarkLockup } from "./Wordmark";

const go = (id) => (e) => {
  e.preventDefault();
  scrollToId(id);
};

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden">
    <div className="relative h-[460px] sm:h-[560px] lg:h-[640px]">
      <img
        src="/assets/horizon_family.jpg"
        alt="A family silhouetted on the glowing horizon of the earth at night"
        data-testid="footer-horizon-image"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover object-[50%_70%]"
      />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#030507] to-transparent" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[#030507] to-transparent" />
      <div className="absolute inset-x-0 top-[13%] px-4 text-center sm:top-[15%]">
        <p className="cl-kicker pl-[0.36em] text-[#C9D3DE]">YOUR STORY. ACROSS GENERATIONS.</p>
        <WordmarkLockup testid="footer-wordmark" className="mt-8 text-xl sm:text-3xl" taglineClass="text-[8px] sm:text-[10px]" />
      </div>
    </div>
    <div className="cl-container relative pb-10">
      <div className="flex flex-col items-center gap-8 border-t border-[#1C2A3A]/70 pt-10">
        <ul className="flex flex-wrap justify-center gap-x-8 gap-y-3">
          {NAV_LINKS.map(({ id, label }) => (
            <li key={id}>
              <a href={`#${id}`} onClick={go(id)} data-testid={`footer-link-${id}`} className="text-[11px] uppercase tracking-[0.2em] text-[#9AAABD] transition-colors hover:text-[#E7C99D]">
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="mt-10 flex flex-col-reverse items-center gap-6 sm:flex-row sm:justify-between">
        <p data-testid="footer-copyright" className="text-xs text-[#9AAABD]/80">© Chronoloop</p>
        <ul className="flex items-center gap-3 text-[11px] font-medium tracking-[0.26em] text-[#9AAABD]">
          {["CONTACT", "PRESS", "INVESTORS"].map((l, i) => (
            <li key={l} className="flex items-center gap-3">
              {i > 0 && <span className="text-[#1C2A3A]">·</span>}
              <a href="#contact" onClick={go("contact")} data-testid={`footer-${l.toLowerCase()}-link`} className="transition-colors hover:text-[#E7C99D]">
                {l}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </footer>
);
